module.exports = __webpack_public_path__ + "static/media/sidebar-459151704b35638cd95da43ba5df24982jpg";